<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ title }}</h4>
          <div class="page-title-right">
            <div class="text-sm-right" v-if="canManageHousing">
              <button type="button" class="btn btn-primary mb-2 mr-2" @click="newHotel()">
                <i class="mdi mdi-plus mr-1"></i> Adicionar Hotel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <roomlist-statistic ref="child"></roomlist-statistic>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-5">
                <h4 class="card-title mb-4">Hotéis</h4>
              </div>
              <div class="col-sm-7">
                <div class="float-sm-end d-flex">
                <div class="search-box mr-2 mb-2">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Buscar hotéis..." @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
                  <div class="text-sm-right me-2 mr-2">

                    <b-dropdown
                      size="md"
                      variant="light"
                      class="m-0 rounded-drop">
                      <template v-slot:button-content >
                        {{ statusList[filter.status] }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <span>
                        <b-dropdown-item-button
                          v-for="(s,idx) in statusList"
                          :key="idx"
                          @click="toggleStatus(idx)"
                        >
                          {{ s }}
                        </b-dropdown-item-button>
                      </span>
                    </b-dropdown>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="20%">Nome</th>
                    <th width="25%">Endereço</th>
                    <th width="15%">Check - In/Out</th>
                    <th width="10%">Capacidade</th>
                    <th width="10%">Quartos ocupados</th>
                    <th width="10%">Status</th>
                    <th width="5%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in hotels" :key="list.id" :class="{ 'link': canManageHousing }">
                    <td @click="canManageHousing && editHotel(list.id)" :style="{ cursor: canManageHousing ? 'pointer' : 'default' }">
                      <h5 class="font-size-14 mb-1" style="white-space: nowrap;text-overflow: ellipsis;max-width: 275px;overflow: hidden;">{{ list.name }}</h5>
                    </td>
                    <td @click="canManageHousing && editHotel(list.id)" :style="{ cursor: canManageHousing ? 'pointer' : 'default' }">
                      <p class="text-muted mb-0">{{ list.address }}</p>
                      <p class="text-muted mb-0">{{ list.city + ', ' +list.state }}</p>
                    </td>
                    <td @click="canManageHousing && editHotel(list.id)" :style="{ cursor: canManageHousing ? 'pointer' : 'default' }">
                      <template v-if="list.date_ranges && list.date_ranges.length">
                        <p class="text-muted mb-0" v-for="range in list.date_ranges" :key="range.id">
                          {{ $moment(range.check_in).format('DD MMM') }} à {{ $moment(range.check_out).format('DD MMM, YYYY') }}
                        </p>
                      </template>
                      <p class="text-muted mb-0" v-else>{{ $moment(list.check_in).format('DD MMM') }} à {{ $moment(list.check_out).format('DD MMM, YYYY') }}</p>
                    </td>
                    <td @click="canManageHousing && editHotel(list.id)" :style="{ cursor: canManageHousing ? 'pointer' : 'default', fontSize: '12px !important', textAlign: 'center' }">{{ list.allocatedRooms }}/{{ list.capacity }}</td>
                    <td @click="canManageHousing && editHotel(list.id)" :style="{ cursor: canManageHousing ? 'pointer' : 'default', fontSize: '12px !important', textAlign: 'center' }">
                      <span class="badge badge-soft-secondary font-size-12 p-2" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden;">
                        {{ list.allocated }}/{{ list.qty_rooms }}
                      </span>
                    </td>
                    <td>
                      <b-dropdown
                        v-if="canManageHousing"
                        size="sm"
                        style="min-width:100px"
                        :variant="(parseInt(list.status)) === 1 ? 'success' : 'danger'"
                      >
                        <template v-slot:button-content >
                          {{ parseInt(list.status) === 1 ? 'Ativo' : 'Inativo' }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <span>
                          <b-dropdown-item-button @click="changeStatus(list.id)" v-if="parseInt(list.status) !== 1">Ativar</b-dropdown-item-button>
                          <b-dropdown-item-button @click="changeStatus(list.id)" v-if="parseInt(list.status) !== 2">Inativar</b-dropdown-item-button>
                        </span>
                      </b-dropdown>
                      <span v-else class="badge font-size-12" style="min-width:100px" :class="{
                        'badge-soft-success': parseInt(list.status) === 1,
                        'badge-soft-danger': parseInt(list.status) !== 1
                      }">
                        {{ parseInt(list.status) === 1 ? 'Ativo' : 'Inativo' }}
                      </span>
                    </td>
                    <td>
                      <i v-if="canManageHousing" class="fas fa-trash-alt text-danger mr-1" @click="deleteHotel(list.id)" style="cursor: pointer;"></i>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal-form v-model="modalForm" ref="formHotel" @created="updateList"></modal-form>
      <modal-room v-model="modalRoom" :hotelId="hotelId" ref="formRoom" @created="updateList"></modal-room>
    </div>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import { mapActions, mapState, mapGetters } from 'vuex'
import ModalForm from './Form'
import ModalRoom from './Room'
import Swal from 'sweetalert2'
import roomlistStatistic from '@/components/widgets/roomlist-statistic'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { EventBus } from '@/eventBus'

export default {
  components: {
    ModalForm,
    ModalRoom,
    roomlistStatistic
  },
  name: 'roomlist',
  page: {
    title: 'Gestão de Hospedagem',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      timeout: 60000,
      search: '',
      filter: {
        status: 0
      },
      statusList: ['Todos os status', 'Ativo', 'Inativo'],
      statusLabel: ['', 'Ativo', 'Inativo'],
      modalForm: false,
      modalRoom: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      hotelId: null,
      idParticipant: null,
      submitted: false,
      title: 'Gestão de Hospedagem'
    }
  },
  created () {
    const events = [
      'allocationAdded',
      'allocationRemoved',
      'roomAdded'
    ]

    events.forEach(event => {
      EventBus.$on(event, (action) => {
        if (action) {
          this.updateList()
        }
      })
    })
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('hotel', ['hotels', 'pagination']),
    ...mapGetters('auth', ['hasPermission', 'isSuperAdmin']),
    rows () {
      return this.pagination.total
    },
    canManageHousing () {
      return this.isSuperAdmin || this.hasPermission('housing.manage')
    }
  },
  methods: {
    ...mapActions('hotel', {
      getAll: 'getAll',
      updateStatus: 'changeStatus',
      destroyHotel: 'deleteHotel'
    }),
    toggleStatus (status) {
      this.filter.status = status
      this.getReport()
    },
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    showFilters () {
      this.$refs.modalFilter.open()
    },
    newHotel () {
      this.$refs.formHotel.open('')
      this.modalForm = true
    },
    editHotel (id) {
      this.$refs.formHotel.open(id)
      this.modalForm = true
      this.idGuest = id
    },
    openRooms (id) {
      this.$refs.formRoom.open(id)
      this.modalRoom = true
      this.hotelId = id
    },
    async changeStatus (id) {
      try {
        await this.updateStatus({ id })
        let message = 'Sucesso: Status atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.updateList()
      } catch (err) {
        errorMessage('Alerta: ' + err.message)
      }
    },
    deleteHotel (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyHotel(id).then((res) => {
              successMessage('Sucesso: Hotel excluído com sucesso.', 2500)
              this.updateList()
              EventBus.$emit('hotelRemoved', 1)
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        include: 'rooms',
        status: this.filter.status || null,
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: auto !important;}
.float-sm-end { float: right }
</style>
